export const BLOCK_PADDING = 20;
